import React from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';

interface DeletePlaylistDialogProps {
  open: boolean;
  playlistName: string;
  onClose: () => void;
  handleAction: () => void;
}

export const DeletePlaylistDialog = ({
  open = false,
  playlistName,
  onClose,
  handleAction,
}: DeletePlaylistDialogProps) => {
  return (
    <ChakraConfirmationDialog
      title="Delete Playlist"
      actionButtonText="Delete"
      handleAction={handleAction}
      isOpen={open}
      onClose={onClose}
      message={
        <>
          Are you sure you want to delete playlist <i>{playlistName}</i> ? It
          will be deleted permanently alongside any share links created.
        </>
      }
    />
  );
};
